import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../models/enums.generated';
import { camps } from '../../../../models/models.generated';
import { WaiveApiService } from '../../../../services/api/waive-api.service';
import { CampsEnumTranslationService } from '../../../../services/camps-enum-translation.service';

@Component({
    selector: 'app-purchase-edit-summary',
    templateUrl: './purchase-edit-summary.component.html',
    styleUrls: ['./purchase-edit-summary.component.scss'],
    standalone: false
})
export class PurchaseEditSummaryComponent {
    @Input()
    public purchaseSetId: camps.Guid;

    @Input()
    public summary: camps.PurchaseModificationSummaryInfo;

    @Output()
    public purchaseSummaryChanged: EventEmitter<any> = new EventEmitter<boolean>();

    constructor(
        private enumTranslations: CampsEnumTranslationService,
        private waiveApi: WaiveApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    public translatePaymentMethod(paymentMethod: campsenum.PaymentMethod) {
        return this.enumTranslations.paymentMethod(paymentMethod);
    }

    public waiveCancellation() {
        this.waiveApi.waiveCancellation(this.purchaseSetId).subscribe(x => {
            if (x.isSuccess) {
                this.purchaseSummaryChanged.emit(true);
            } else {
                this.errorTranslate.translateValidationNotifications(x.validationNotification);
                this.alert.showError(x.validationNotification.errors[0].message);
            }
        });
    }

    public waiveDiscounts() {
        //future versions
        // this.waiveApi.waiveDiscounts(this.purchaseSetId)
        //     .subscribe(x=>{
        //         if(x.isSuccess){
        //             this.purchaseSummaryChanged.emit(true);
        //         }}
        //     )
    }

    public get appendWeeksRefundInfo() {
        return (
            this.summary.creditDaysNumberChange > 0 &&
            this.summary.originalTender.paymentMethod != campsenum.PaymentMethod.CreditDays
        );
    }
}
